<div [ngStyle]="{ 'display' : analysisToolService.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <form autocomplete="off"  id="ngAnalysisTool" [ngClass]="[this.analysisToolService.active ? 'active margin-tabs' : 'margin-tabs',  tabsService.fullScreenMode ? 'fullscreen margin-tabs' : 'margin-tabs']" name="ngAnalysisTool" #ngngAnalysisTool="ngForm" id="analysisToolForm" >
    <div class="fields__block">
        <div class="fields__block__section">
            <div class="title">
              <h4 >{{analysisToolService.title}}</h4>
              <span> </span>
            </div>
            <ng-container *ngIf="showNavaidSelection()">
              <div *ngIf="!analysisToolService.isPairsAnalysis()" class="dropdown-fields">
                <div *ngIf="analysisToolService.isImpactAssessment()">
                  <label for="">Type Selection</label>
                  <input id="jamming" type="checkbox" checked (change)="filterTransmitter()"/>
                  <label for="jamming">Jamming</label>
                  <input id="spoofing" type="checkbox" checked (change)="filterTransmitter()"/>
                  <label for="spoofing">Spoofing</label>
                </div>
                <div>
                  <label for="">Entity Selection</label>
                  <select name="navaid" id="navaidSelect" [(ngModel)]="analysisToolService.selectedNavaid" (change)="analysisToolService.onSelectChange()">
                    <option value="ALL">ALL</option>
                    <option *ngFor="let navaid of analysisToolService.info | keyvalue" [value]="navaid.key">{{navaid.key.split("_")[0]}}</option>
                  </select>
                </div>
              </div>
              <div *ngIf="analysisToolService.isPairsAnalysis()" class="table-fields">
                <div>
                  <label for="">NavAid Selection</label>
                  <div>
                    <table>
                      <thead>
                        <tr>
                          <th>Show</th>
                          <th scope="col">Id</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr mdbTableCol *ngFor="let navaid of analysisToolService.navaids_info | keyvalue">
                          <td><input
                            type="checkbox"
                            id="showNavaid_{{navaid.key}}"
                            name="showNavaid_{{navaid.key}}"
                            [ngModel]="analysisToolService.selectedNavaids.includes(navaid.key)"
                            (click)="onCheckBoxClick(navaid.key, $event)"
                            /></td>
                          <td>{{ navaid.key }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="btn">
                      <a (click)="updateMap()">Update Map</a
                      ><a (click)="showAll()">Show All</a>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <div *ngIf="analysisToolService.isPairsAnalysis()" class="dropdown-fields">
              <div>
                <label for="">Criticallity</label>
                <select name="criticallity" id="criticallity" [(ngModel)]="analysisToolService.criticallity" (change)="updateMap()">
                  <option value="ALL">ALL</option>
                  <option value="CRITICAL">CRITICAL</option>
                </select>
              </div>
            </div>
            <div *ngIf="analysisToolService.isPairsAnalysis() && analysisToolService.criticalNavaids.length > 0" class="table-fields">
              <div>
                <div>
                  <table>
                    <thead>
                      <tr>
                        <th scope="col">Id</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr mdbTableCol *ngFor="let nav of analysisToolService.criticalNavaids">
                        <td>{{ nav }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div *ngIf="!analysisToolService.isPairsAnalysis()" style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                <label for="elevationSlider" >Elevation Selection</label>
                <ngx-slider
                  [options]="analysisToolService.sliderOptions"
                  [(value)]="analysisToolService.sliderValue"
                  (valueChange)="analysisToolService.onSliderChange()">
                </ngx-slider>
                <span>Elevation: {{analysisToolService.selectedElevation}} [ft]</span>
            </div>
        </div>
    </div>
  </form>
</div>
